function handleValidation(event, target) {
    let isValid = true;
    let errorMessage = '';

    toggleSubmitBtn(target.querySelector('[type="submit"]'), true)

    // Check required text inputs
    const requiredInputs = target.querySelectorAll('input[required], select[required]');
    for (let input of requiredInputs) {
        if (!input.value.trim()) {
            isValid = false;
            errorMessage += `Please fill out the ${input.getAttribute('data-field-name')} field.\n`;
        }
    }

    // Check if at least one checkbox is checked
    const checkboxGroups = target.querySelectorAll('fieldset[data-minimum-selection]');
    checkboxGroups.forEach(group => {
    let checkboxes = group.querySelectorAll('input[type="checkbox"]');
    let checkedCount = Array.from(checkboxes).filter(checkbox => checkbox.checked).length;
    if (checkedCount < parseInt(group.getAttribute('data-minimum-selection'))) {
        isValid = false;
        errorMessage += `Please select at least ${group.getAttribute('data-minimum-selection')} product.\n`;
    }
    })

    // If not valid, prevent form submission and show error message
    if (!isValid) {
        event.preventDefault();
        toggleSubmitBtn(target.querySelector('[type="submit"]'), false)
        alert(errorMessage); // Replace with a more user-friendly error display
    } else {
        event.preventDefault();
        toggleSubmitBtn(target.querySelector('[type="submit"]'), false)
        postFormData(target)
    }
}

function toggleSubmitBtn(btn, disabled) {
    btn.disabled = disabled
}

function formSuccess(target) {
    let parent = target.closest('div')
    target.remove();
    if (target.id !== 'refer-friend-form') {
        parent.innerHTML = `
            <h4 class="h3 mt1 mb0">Success!</h4>
            <p class="mt1 mb0">Your form has been submitted successfully. Be sure to check your email to opt-in to receive exclusive content, offers, and more on the world's cleanest personal care devices.</p>
        `
    } else {
        parent.innerHTML = `
            <h4 class="h3 mt1 mb0">Success! Your referral code is: <span class="color--1"3D102Y37X1G7FCNZ</span></h4>
            <div class="mt1">
                <p class="mt0 mb1">Share the link <a href="https://taoclean.com/referral/" target="_blank">TAOClean.com/referral</a> to give 50% OFF to your friends and family on any TAO Clean device purchase!</p>
                <div>
                    <a class="ub_share-item headUp" href="sms:+&amp;body=Use%20my%20personal%20coupon%20code%203D102Y37X1G7FCNZ%20at%20TAOClean.com%2Freferral%20to%20receive%2050%25%20off%20your%20order!" target="_blank">
                        <div class="ub_share-icon-wrap">
                            <img src="https://cdn.shopify.com/s/files/1/1009/8326/files/SMS_1.png?v=1603078281">
                        </div>
                        Share via SMS
                    </a>
                    <a class="ub_share-item headUp" href="mailto:?subject=Use%20My%20Discount%20at%20TAO%20Clean&amp;body=Use%20my%20personal%20coupon%20code%203D102Y37X1G7FCNZ%20at%20TAOClean.com%2Freferral%20to%20receive%2050%25%20off%20your%20order!" target="_blank">
                        <div class="ub_share-icon-wrap">
                            <img src="https://cdn.shopify.com/s/files/1/1009/8326/files/Email_1.png?v=1603078281">
                        </div>
                        Share via Email
                    </a>
                    <a class="fb-share-button ub_share-item headUp" href="https://www.facebook.com/share.php?u=https://taoclean.com/referral" target="_blank">
                        <div class="ub_share-icon-wrap">
                            <img src="https://cdn.shopify.com/s/files/1/1009/8326/files/Facebook_1.png?v=1603078282">
                        </div>
                        Share on Facebook
                    </a>
                    <a class="ub_share-item headUp" href="https://twitter.com/messages/compose?text=Use%20my%20referral%20code%203D102Y37X1G7FCNZ%20at%20TAOClean.com%2Freferral%20to%20receive%2050%25%20off%20your%20order!" target="_blank">
                        <div class="ub_share-icon-wrap">
                            <img src="https://cdn.shopify.com/s/files/1/1009/8326/files/Twitter_1.png?v=1603078281">
                        </div>
                        Share on Twitter
                    </a>
                </div>
            </div>
        `
    }
}

async function postFormData(form) {
    const endpoint = form.getAttribute('data-form-endpoint')
    if (!endpoint) return;
    let formData = new FormData(form)
    formData.append('form-id', form.id)
    try {
        let response = await fetch(endpoint, {
            method: "POST",
            body: formData
        })

        let data = await response;
        formSuccess(form)
    } catch (error) {
        console.error('There was an issue submitting your form:', error);
        alert('There was an issue submitting your form. Please reload this page and try again.'); // Inform the user
    }

}

function findForms() {
    let forms = document.querySelectorAll('form[data-custom-validation="true"]');
    forms.forEach(form => {
        form.addEventListener('submit', (event) => {
            handleValidation(event, form)
        })
    })
}

document.addEventListener('DOMContentLoaded', findForms)